export const readStorage = (key: string, session = false): string | null => {
    try { return (session ? window.sessionStorage : window.localStorage).getItem(key); } catch { return null; }
};

export const writeStorage = (key: string, value: string, session = false) => {
    try { (session ? window.sessionStorage : window.localStorage).setItem(key, value); } catch { /* Browser storage may be disabled. */ }
};

export const removeStorage = (key: string, session = false) => {
    try { (session ? window.sessionStorage : window.localStorage).removeItem(key); } catch { /* Browser storage may be disabled. */ }
};
